"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cacheClear = exports.cacheRemove = exports.cacheGet = exports.createDataStats = exports.trackAPIUsage = void 0;
var CoreServiceHelper_1 = require("./provider/airabbi/CoreServiceHelper");
var UserCache_1 = require("./UserCache");
var usageRecords = [];
var lastTimeUpload = 0;
var trackAPIUsage = function (usageUploadInterval, data, cfg) {
    var logger = console;
    var user = (0, UserCache_1.loadUser)();
    if (!user) {
        logger.error('trackAPIUsage', 'User not found!');
        return;
    }
    var record = {
        unit: user.unit,
        units: user.units,
        uid: user.uid,
        uname: user.displayName,
        host: data.host,
        pathname: data.pathname,
        requestEndPoint: data.requestEndPoint,
        reqSize: data.reqSize,
        resSize: data.resSize,
        updated: Date.now(),
        queryTime: data.queryTime
    };
    usageRecords.push(record);
    var now = Date.now();
    if (now - lastTimeUpload < usageUploadInterval) {
        return;
    }
    if (usageRecords) {
        var copyRecords = [].concat(usageRecords);
        usageRecords = [];
        var recordCount = copyRecords.length;
        lastTimeUpload = now;
        var totalQueryTime_1 = 0;
        var totalSize_1 = 0;
        copyRecords.forEach(function (r) {
            totalQueryTime_1 += r.queryTime ? r.queryTime : 0;
            totalSize_1 += parseInt(r.reqSize) + parseInt(r.resSize);
        });
        var avgQueryTime = recordCount > 0 ? totalQueryTime_1 / recordCount : 0;
        var avgSize = recordCount > 0 ? totalSize_1 / recordCount : 0;
        var recordData_1 = {
            usages: copyRecords,
            count: recordCount,
            totalQueryTime: totalQueryTime_1,
            totalSize: totalSize_1,
            avgQueryTime: avgQueryTime,
            avgSize: avgSize
        };
        CoreServiceHelper_1.CoreServiceHelper.getHelper(cfg)
            .insertRecordData('api_usage', recordData_1)
            .then(function (result) {
            logger.log('trackAPIUsage#api_usage#ok', recordData_1);
        })
            .catch(function (err) {
            logger.error('trackAPIUsage#api_usage#error', err);
        });
        return;
    }
};
exports.trackAPIUsage = trackAPIUsage;
var createDataStats = function (data, cfg) {
    if (data) {
        return;
    }
    var logger = console;
    var user = (0, UserCache_1.loadUser)();
    if (!user) {
        logger.error('User not found!');
        return;
    }
    var size = JSON.stringify(data).length;
    var statsText = localStorage.getItem("stats_".concat(user.uid));
    logger.log('createDataStats#local#statsText:', statsText);
    var stats = {
        unit: user.unit,
        units: user.units,
        uid: user.uid,
        uname: user.displayName,
        count: 0,
        total: 0,
        updated: 0
    };
    if (statsText) {
        stats = JSON.parse(statsText);
    }
    else {
        stats = {
            unit: user.unit,
            units: user.units,
            uid: user.uid,
            uname: user.displayName,
            count: 0,
            total: 0,
            updated: Date.now()
        };
    }
    stats.count = stats.count + 1;
    stats.total = stats.total + size;
    logger.log('createDataStats#local#stats', stats);
    logger.log('createDataStats#local#timediff', Date.now() - stats.updated);
    var countTime = 60 * 5 * 1000;
    if (Date.now() - stats.updated >= countTime) {
        localStorage.removeItem("stats_".concat(user.uid));
        CoreServiceHelper_1.CoreServiceHelper.getHelper(cfg)
            .createData('data_stats', stats)
            .then(function (result) {
            logger.log('createDataStats#data_stats#ok', stats);
        })
            .catch(function (err) { return logger.log(err); });
        stats.updated = Date.now();
        stats.total = 0;
        localStorage.setItem("stats_".concat(user.uid), JSON.stringify(stats));
    }
    else {
        logger.log('createDataStats#data_stats#not-yet!!!!!!', Date.now() - stats.updated);
        localStorage.setItem("stats_".concat(user.uid), JSON.stringify(stats));
    }
};
exports.createDataStats = createDataStats;
var cacheGet = function (key) {
    return localStorage.getItem(key);
};
exports.cacheGet = cacheGet;
var cacheRemove = function (key) {
    localStorage.removeItem(key);
};
exports.cacheRemove = cacheRemove;
var cacheClear = function () {
    localStorage.clear();
};
exports.cacheClear = cacheClear;
//# sourceMappingURL=DataStatsManager.js.map